import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { message } from 'antd';
import { getAuth, applyActionCode } from 'firebase/auth';
import './auth.css';
import AuthShell from '../../ui/AuthShell';
import Card from '../../ui/Card';
import Button from '../../ui/Button';

const VerifyEmail = () => {
  const [verified, setVerified] = useState(false);
  const auth = getAuth();
  const location = useLocation();
  const actionCode = new URLSearchParams(location.search).get('oobCode');

  const handleVerifyEmail = async () => {
    try {
      await applyActionCode(auth, actionCode);
      setVerified(true);
      message.success('Email verified successfully!');
    } catch (error) {
      message.error('Invalid or expired action code.');
    }
  };

  return (
    <AuthShell>
      <Card className="auth-form-wrapper" style={{ padding: 24 }}>
        <div className="auth-header" style={{ textAlign: 'center', marginBottom: 8 }}>
          <h2 style={{ margin: '12px 0 6px', fontWeight: 700, color: '#0f172a' }}>Verify email</h2>
          <p style={{ margin: 0, color: '#334155' }}>Confirm your email to complete setup.</p>
        </div>
        {!verified ? (
          <Button type="button" onClick={handleVerifyEmail} className="vs-btn vs-btn-primary" style={{ width: '100%' }}>
            Verify email
          </Button>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <p>Your email has been verified. You can now <Link to="/auth/login" className="auth-form-link">sign in</Link>.</p>
          </div>
        )}
      </Card>
    </AuthShell>
  );
};

export default VerifyEmail;
